import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { tracked } from '@glimmer/tracking';

import type { PopupData } from 'webapp-types';

import DesignerTopbarDataboardSelectListComponent from 'webapp/components/designer/topbar/databoard-select-list';
import type { Args } from 'webapp/components/popup/inner/context';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

import type Board from 'webapp/models-custom/board';
import BoardLoop from 'webapp/models-custom/board-loop';
import type { ViewType } from 'webapp/models-custom/filter-sort/mixed-in-designer';

export default class DesignerTopbarPopupDataboardsComponent extends PopupInnerContextComponent<PopupData.Designer.Topbar.Databoards> {
	@tracked selectedBoardLoop: BoardLoop | null = null;
	@tracked selectedBoard: Board | null = null;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.selectedBoard = this.popupData.selectedBoard;
		this.selectedBoardLoop = this.popupData.selectedBoardLoop;
	}

	@action
	changeSelection(item: Board | BoardLoop) {
		if (item instanceof BoardLoop) {
			this.selectedBoardLoop = item;
		} else {
			this.selectedBoard = item;
		}

		this.popupData.onChangeSelection(item);
	}

	@action
	createNew(viewType: ViewType) {
		this.popupData.onCreateNew(viewType);
	}
	<template>
		<DesignerTopbarDataboardSelectListComponent
			@selectedBoard={{this.selectedBoard}}
			@selectedLoop={{this.selectedBoardLoop}}
			@onChange={{this.changeSelection}}
			@onCreateNew={{this.createNew}}
			@onClose={{this.close}}
		/>
	</template>
}
